const ConcatClasses = (array) => array.join(' ');

export default ConcatClasses;